import React, { useEffect } from "react";
import Iframe from "react-iframe";
import "./style.css";

const index = () => {
  return (
    // <Iframe
    //   url="http://39.104.136.10:3013"
    //   id="myId"
    //   className="myClassname"
    //   position="relative"
    // />
    <h2 className="Operation">开发中</h2>
  );
};

export default index;
